<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.executor" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.responsible && !checkIfSignIsExist(user.id, 'responsible')" @click="$var('acceptResp', true)">Подписать Инфо контроль</n-button>
      <n-button v-if="edit.executor && !checkIfSignIsExist(user.id, 'executor')" @click="$var('acceptExec', true)">Качество изоляции соответствует проекту</n-button>
      <n-button v-if="edit.quality && !checkIfSignIsExist(user.id, 'quality')" @click="$var('acceptQual', true)">Качество изоляции соответствует проекту</n-button>
      <n-button v-if="edit.tech && !checkIfSignIsExist(user.id, 'tech')" @click="$var('acceptTech', true)">Качество изоляции соответствует проекту</n-button>
      <n-button v-if="edit.geodesist && !checkIfSignIsExist(user.id, 'geodesist')" @click="$var('acceptGeo', true)">Контроль укладки трубопровода на проектные отметки</n-button>
      <n-button v-if="edit.executor && !checkIfSignIsExist(user.id, 'place.executor')" @click="$var('acceptPlaceExec', true)">Ремонт изоляции после укладки выполнен</n-button>
      <n-button v-if="edit.tech && !checkIfSignIsExist(user.id, 'place.tech')" @click="$var('acceptPlaceTech', true)">Ремонт изоляции после укладки выполнен</n-button>
      <n-button v-if="edit.executor && !checkIfSignIsExist(user.id, 'done.executor')" @click="$var('acceptDoneExec', true)">Укладка и балластировка соответствуют техническим требованиям</n-button>
      <n-button v-if="edit.quality && !checkIfSignIsExist(user.id, 'done.quality')" @click="$var('acceptDoneQual', true)">Укладка и балластировка соответствуют техническим требованиям</n-button>
      <n-button v-if="edit.tech && !checkIfSignIsExist(user.id, 'done.tech')" @click="$var('acceptDoneTech', true)">Укладка и балластировка соответствуют техническим требованиям</n-button>
    </div>
    <br />
    <n-items>
      <n-datepicker inline title="Дата" v-bind="$form.input('date')" :text="!edit.executor" />
      <n-input title="Границы участка, км, пк" v-bind="$form.input('border')" :text="!edit.executor" />
      <n-input title="Температура воздуха °С" v-bind="$form.input('airTemp')" :text="!edit.executor" />
      <n-input title="Изоляция: вид (п.бр. и т.д.) т и п (У, Н) конструкция (1 1, 1 2, 2 2 и т.п.)" v-bind="$form.input('isolation1')" :text="!edit.executor" />
      <n-input title="Изоляция: Марка клея (Праймера) и марка изоляционной ленты, к-во слоев" v-bind="$form.input('isolation2')" :text="!edit.executor" />
      <n-input title="Изоляция: Марка оберточного материала, к-во слоев" v-bind="$form.input('isolation3')" :text="!edit.executor" />
      <n-input title="Изоляция: Сведения о производственном контроле качества выполняемых работ: метод контроля" v-bind="$form.input('isolation4')" :text="!edit.executor" />
      <n-input title="Укладка и балластировка: Сведения о производственном контроле укладки трубопровода на проектные отметки: проектные отметки верха трубы после укладки" v-bind="$form.input('placing1')" :text="!edit.executor" />
      <n-input title="Укладка и балластировка: Сведения о производственном контроле укладки трубопровода на проектные отметки: фактические отметки верха трубы после укладки" v-bind="$form.input('placing2')" :text="!edit.executor" />
      <n-input title="Укладка и балластировка: Границы участка балластировки от км (пк) до км (пк)" v-bind="$form.input('placing6')" :text="!edit.executor" />
      <n-input title="Укладка и балластировка: Тип, вес балластировочных устройств, удерживающая способность анкерных устройств" v-bind="$form.input('placing7')" :text="!edit.executor" />
      <n-input title="Укладка и балластировка: Шаг пригрузки" v-bind="$form.input('placing8')" :text="!edit.executor" />
      <n-input title="Примечания" v-bind="$form.input('remark')" :text="!edit.executor" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.executor" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>

    <c-modal-journal-do-sign v-if="$var('acceptResp')" @close="$var('acceptResp', false)" @submit="(s) => accept('responsible', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptExec')" @close="$var('acceptExec', false)" @submit="(s) => accept('executor', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptQual')" @close="$var('acceptQual', false)" @submit="(s) => accept('quality', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptTech')" @close="$var('acceptTech', false)" @submit="(s) => accept('tech', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptGeo')" @close="$var('acceptGeo', false)" @submit="(s) => accept('geodesist', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptPlaceExec')" @close="$var('acceptPlaceExec', false)" @submit="(s) => accept('place.executor', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptPlaceTech')" @close="$var('acceptPlaceTech', false)" @submit="(s) => accept('place.tech', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptDoneExec')" @close="$var('acceptDoneExec', false)" @submit="(s) => accept('done.executor', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptDoneQual')" @close="$var('acceptDoneQual', false)" @submit="(s) => accept('done.quality', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptDoneTech')" @close="$var('acceptDoneTech', false)" @submit="(s) => accept('done.tech', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        responsible: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_responsible', this.project.id),
        executor: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_executor', this.project.id),
        tech: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_tech', this.project.id),
        quality: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_quality', this.project.id),
        geodesist: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_geodesist', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec51.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec51.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
